import { render, staticRenderFns } from "./NoDeliverySlotsNotice.vue?vue&type=template&id=18503616&"
import script from "./NoDeliverySlotsNotice.vue?vue&type=script&lang=ts&"
export * from "./NoDeliverySlotsNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports